export const getPageTitle = ({
  editorStateSelectors
}) => {
  const {
    selectContentModelHtmlTitle
  } = editorStateSelectors;
  return selectContentModelHtmlTitle();
};